
import PaymentService  from "../payment.service";
  /**
   * Abstract Bank
   * La clase Bank es una abstraccion para que clases bancos puedan asignar su propia lógica
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Diciembre 2024 - Crear clase Bank
   */
  
export  class Bank{
    constructor(name,type){
        if(new.target === Bank)throw new Error('Clase Bank no puede instanciarse directamente')
        this.name = name;
        this.type = type   
    }
    hash(){
        throw new Error('El método hashing debe ser implementado por una sub clase')
    }
    getFormFields(){
        throw new Error('El método getFormFields debe ser implementado por una subclase.')
    }
    async savePaymentRequest(){
        throw new Error('El método savePaymentRequest debe ser implementado por una subclase.')
    }
    async startPostPayment(){
        throw new Error('El método startPostPayemnt  debe ser implementado por una subclase.')
    }
    async startMultipartPayment(){
        throw new Error('El método startPostPayemnt  debe ser implementado por una subclase.')
    }
    async executePayment(data) {
        const method = this.paymentMethods[this.type]
        if(!method){
          throw new Error('Invalid payment method')
        }
        return await method(data)
      }
     async startPayment(reference, paymentArray,an8){
        try{
            if(!reference || !paymentArray.length || !an8 ) throw new Error("Ha ocurrido un error")
            await PaymentService.startPayment(reference,paymentArray,an8)
            return {success:"Payment has started..."}
        }catch(error){
            return  {error:"Ha ocurrido un error..."}
        }
    }
  /**
   * Comienza el servicio de pagos de anticipo
   * Funcion que comienza el servicio de pagos de anticipo
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Diciembre 2024 - CServicio pagos de anticipo
   */
    async startAdvancePayment(advancePaymentArray, an8){
        try{
            await PaymentService.startAdvancePayment(advancePaymentArray, an8)
            return {success:"Advance Payment has started..."}
        }catch(err){
            return {error: err.message}
        }
    }
    /**
   * Handle close
   * Cancela pagos de facturas
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Diciembre 2024 - Cancelar pagos
   */
    async cancelPaymentRequest(dataStartPayment, an8) {
        const dataToSend = {
            reference: dataStartPayment.reference,
            bill: dataStartPayment.paymentArray,
        }
        try {
            const response = await PaymentService.cancelPayment(dataToSend, an8);
            if (!response.data && response.message !== "Proceso realizado correctamente") {
                return { error: response.message };
            }
            return { success: "Ok" };
        } catch (err) {
            return { error: err.message };
        }
    }
        /**
   * Handle close
   * Cancela pagos de anticipo
   * @author Kenzo Sashida - ETE
   * @version 1.0.0 - Diciembre 2024 - Cancelar pagos
   */
    async cancelAdvancePaymentRequest(dataStartPayment,an8){
        try {
            const response = await PaymentService.cancelAdvancePayment(dataStartPayment, an8);
            if (!response.data && response.message !== "Proceso realizado correctamente") {
                return { error: response.message };
            }
            return { success: "Ok" };
        } catch (err) {
            return { error: err.message };
        }
    }
}

